import React, { ReactNode, useState } from 'react';
import {
  Box,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { ErrorBox, ErrorTitle, ErrorMessage } from '@marageti/z4-lib';
import { GoogleLoginRequest } from '@marageti/z4-sdk/lib/auth/Token';

interface GoogleLoginViewProps {
  onSuccess: (d: GoogleLoginRequest) => void;
  /** Rendered under the button, constrained to the button width. */
  error?: ReactNode;
}

const GoogleLoginView = ({
  onSuccess,
  error,
}: GoogleLoginViewProps): React.ReactElement => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [googleError, setGoogleError] = useState(false);

  const onFailure = (): void => {
    setGoogleError(true);
  };

  const handleSuccess = (googleUserToken: CredentialResponse): void => {
    setGoogleError(false);
    const loginRequest: GoogleLoginRequest = {
      googleToken: googleUserToken.credential || '',
    };
    onSuccess(loginRequest);
  };

  const buttonWidth = isDesktop ? '400' : '250';

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Stack spacing={1} sx={{ width: Number(buttonWidth), maxWidth: '100%' }}>
        <GoogleLogin
          key={buttonWidth}
          logo_alignment="left"
          onError={onFailure}
          onSuccess={handleSuccess}
          shape="square"
          size="large"
          text="signin_with"
          width={buttonWidth}
        />
        {error}
        {googleError && (
          <ErrorBox>
            <ErrorTitle>
              There was an error logging in to your Google account.
            </ErrorTitle>
            <ErrorMessage>
              Please check your credentials
            </ErrorMessage>
          </ErrorBox>
        )}
      </Stack>
    </Box>
  );
};

export default GoogleLoginView;
